import React from 'react';
import FormWizard from '../FormWizard';
import DirectDepositForm from './DirectDepositForm';

const DirectDepositFormPage = () => {
  return (
    <FormWizard 
      formId={9}
      formTitle="Direct Deposit Agreement"
      formTitleEs="Acuerdo de Depósito Directo"
    >
      <DirectDepositForm />
    </FormWizard>
  );
};

export default DirectDepositFormPage;

